import S0 from '../assets/images/San Jose State University.jpg'
import S3 from '../assets/images/Logo_HCM-UTE.png'
// import Arun from '../assets/images/vice_chancellor_img.jpg'
// import Alex from '../assets/images/Alex Stojcevski.jpg'
import CurtinLogo from '../assets/images/Curtin Singapore logo - keyline.jpg'
import APAQA from '../assets/images/APAQA_Logo.png'
import Hilton from '../assets/images/Hilton.jpg'

function VenueAccommodation() {
    return (
        <div>
            <div className="about-layout">
                <main className="about-main">
                    <h2>Venue and Accommodation</h2>
                    <p className="no-newline-after-p">The IETBHEC'27 Organising Committee has negotiated an exclusive contract with leading international 5-star hotels in Da Nang for registered conference participants. This will provide extremely reasonable and affordable room rates exclusively for IETBHEC'27 registered participants. The booking link and all relevant information will be available here in due course. Therefore, participants are strongly advised to stay at the recommended hotel, as the Conference Gala Banquet will be held at the hotel. Also, the daily transportation to the conference venue will be provided from the hotel.</p>
                    <br></br>
                    <p>In addition, the options for budget hotel accommodation will be provided here in due course.</p>
                    {/* <div className="px-5">
                <ol>
                    <li className="NoPaddingOrMargin">
                        <p>Ibis Budget Singapore West Coast (2 star)</p>
                        <p>Room category: Super room with 1 double bed (with window). No breakfast. Per room per night: $136 est</p>
                        <p>Distance: 8 mins by bus</p>
                    </li>
                    <br></br>
                    <li className="NoPaddingOrMargin">
                        <p>Ibis Budget Singapore Mount Faber (2 star)</p>
                        <p>Room category: Deluxe Theme room with 1 double bed (with window). No breakfast. Per room per night: $117 est</p>
                        <p>Distance: 20 mins by bus</p>
                    </li>
                    <br></br>
                    <li className="NoPaddingOrMargin">
                        <p>Hotel Faber Park Singapore (4 star)</p>
                        <p>Room category: Superior room with 1 double bed. No breakfast. Per room per night: $205 est</p>
                        <p>Distance: 20 mins by bus</p>
                    </li>
                    <br></br>
                    <li className="NoPaddingOrMargin">
                        <p>Travelodge Harbourfront (4 star)</p>
                        <p>Room category: Standard Queen. No breakfast. Per room per night: $186 est</p>
                        <p>Distance: 30 mins by bus</p>
                    </li>
                </ol>
            </div> */}
                </main>

                <aside className="about-sidebar">
                    <img src={Hilton} alt="" width="110%"/>
                </aside>
            </div>

            <section className="sponsor-strip">
                <h4>Proudly supported by</h4>

                <div className="sponsor-strip-logos">
                    <img src={S0} alt="" />
                    <img src={S3} alt="" />
                    <img src={CurtinLogo} alt="" />
                    <img src={APAQA} alt="" />
                </div>
            </section>          
        </div>
    )
}

export default VenueAccommodation